import { render } from "./PatientsFilterDropdown.vue?vue&type=template&id=a44a449c&scoped=true"
import script from "./PatientsFilterDropdown.vue?vue&type=script&lang=js"
export * from "./PatientsFilterDropdown.vue?vue&type=script&lang=js"

import "./PatientsFilterDropdown.vue?vue&type=style&index=0&id=a44a449c&scoped=true&lang=css"

import exportComponent from "/builds/boikovky/medsafe-stat-new/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a44a449c"]])

export default __exports__